// --- 消息管理 --- //

export default [
  {
    name: 'messageList',
    path: '/platformManagement/messageManagement/messageList',
    meta: { title: '消息列表' },
    component: require('business/platformManagement/messageManagement/messageList/list.vue').default
  }
]
